function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { usePopper } from 'react-popper';
import styles from './styles.module.scss';

function generateGetBoundingClientRect() {
  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
  var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  return function () {
    return {
      width: 0,
      height: 0,
      top: y,
      right: x,
      bottom: y,
      left: x
    };
  };
}

var virtualElement = {
  getBoundingClientRect: generateGetBoundingClientRect()
};

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show,
      x = _ref.x,
      y = _ref.y,
      _ref$followMouse = _ref.followMouse,
      followMouse = _ref$followMouse === void 0 ? false : _ref$followMouse;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      popperElement = _useState2[0],
      updatePoperElement = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      arrowElement = _useState4[0],
      updateArrowElement = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      listening = _useState6[0],
      setListening = _useState6[1];

  var _usePopper = usePopper(virtualElement, popperElement, {
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowElement
      }
    }, {
      name: 'offset',
      options: {
        offset: [0, followMouse ? 5 : 20]
      }
    }],
    placement: 'top'
  }),
      stylesPopper = _usePopper.styles,
      attributes = _usePopper.attributes,
      update = _usePopper.update;

  useEffect(function () {
    var mouseMoveHandler = function mouseMoveHandler(_ref2) {
      var clientX = _ref2.clientX,
          clientY = _ref2.clientY;
      virtualElement.getBoundingClientRect = generateGetBoundingClientRect(clientX, clientY);
      update && update();
    };

    if (update) {
      if (followMouse && !listening) {
        document.addEventListener('mousemove', mouseMoveHandler);
        setListening(true);
      } else {
        virtualElement.getBoundingClientRect = generateGetBoundingClientRect(x, y);
        update();
      }
    }

    return function () {
      if (listening) {
        document.removeEventListener('mousemove', mouseMoveHandler);
      }
    };
  }, [update, x, y, followMouse, listening]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: updatePoperElement,
    style: stylesPopper.popper
  }, attributes.popper, {
    className: styles.tooltip
  }), show && /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement("div", {
    ref: updateArrowElement,
    style: stylesPopper.arrow,
    className: styles.arrow
  })));
};

export default Tooltip;